import React from 'react'
import Select from 'react-select';
import { makeDarkSelectStyles } from '../selectStyles';

export default function SelectPublished({ callback, value, width ,name="status" }) {

    const customStyles = makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Published",
            value: 1
        },
        {
            label : "Not Published",
            value : 0
        },
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="Status"
                    value={options && options.filter(obj => obj.value === value)}


                />
            </div>
            
        </>
    )
}
